export enum ChatTokenType {
  ContactEmployee = 'CONTACT_EMPLOYEE',
  OnboardingDSE = 'ONBOARDING_DSE',
  OnboardingTOMs = 'ONBOARDING_TOMS',
  OnboardingCheckup = 'ONBOARDING_CHECKUP',
  OnboardingVVT = 'ONBOARDING_VVT',
  OnboardingVVTMittwald = 'ONBOARDING_VVT_MITWALD',
  OnboardingAVV = 'ONBOARDING_AV',
  OnboardingAVVMittwald = 'ONBOARDING_AV_MITWALD',
  OnboardingImprint = 'ONBOARDING_IMPRINT',
  OnboardingInfo = 'ONBOARDING_INFO',
  OnboardingFacebook = 'ONBOARDING_FACEBOOK',
  OnboardingInstagram = 'ONBOARDING_INSTAGRAM',
  OnboardingLinkedIn = 'ONBOARDING_LINKEDIN',
  OnboardingTikTok = 'ONBOARDING_TIKTOK',
  OnboardingXING = 'ONBOARDING_XING',
  OnboardingDSFA = 'ONBOARDING_DSFA',
  OnboardingEmployeeCommitment = 'ONBOARDING_EMPLOYEE_COMMITMENT',
  OnboardingCreateAccount = 'ONBOARDING_CREATE_ACCOUNT',
}
